<template>
  <div class="customizer-layout">
    <!-- Left Sidebar: Controls -->
    <aside class="controls-sidebar">
      <header class="controls-header">
        <button class="sci-btn-back mb-3" @click="home">
          <i class="fas fa-arrow-left"></i>
          <span>{{ $t('gestionale') || 'Gestionale' }}</span>
        </button>
        <h1>{{ $t('scegli_layout') }}</h1>
        <p class="subtitle">{{ $t('personalizza_aspetto') }}</p>
      </header>

      <div class="scroll-area">
        <!-- Section: Design -->
        <section class="control-section">
          <h2 class="section-title"><i class="fas fa-palette"></i> {{ $t('design') }}</h2>
          
          <div class="form-group">
            <label>{{ $t('colore_principale') }}</label>
            <div class="color-picker-wrapper">
              <ColorPicker
                theme="light"
                :color="color"
                :sucker-hide="true"
                @changeColor="changeColor"
              />
            </div>
          </div>

          <div class="form-group">
            <label>{{ $t('template') }}</label>
            <select v-model="templateId" class="form-select">
              <option value="1">{{ $t('template_1_desc') }} (Centered)</option>
              <option value="2">{{ $t('template_2_desc') }} (Minimalist)</option>
              <option value="3">{{ $t('template_3_desc') }} (Gradient)</option>
              <option value="4">{{ $t('template_4_desc') }} (Elegant)</option>
              <option value="5">{{ $t('template_5_desc') }} (Modern)</option>
              <option value="6">{{ $t('template_6_desc') || 'Template 6' }} (Fresh Modern)</option>
            </select>
          </div>
        </section>

        <!-- Section: Content -->
        <section class="control-section">
          <h2 class="section-title"><i class="fas fa-file-alt"></i> {{ $t('contenuto') }}</h2>
          
          <div class="form-group">
            <label>{{ $t('messaggio_benvenuto') }}</label>
            <input
              type="text"
              v-model="welcome"
              :placeholder="$t('inserisci_frase_benvenuto')"
              class="form-control"
            />
          </div>

          <div class="form-group" v-if="templateId >= 4">
            <label>{{ $t('chi_siamo') }}</label>
            <textarea
              v-model="chiSiamoText"
              :placeholder="$t('descrizione_ristorante')"
              class="form-control"
              rows="4"
            ></textarea>
          </div>

          <div class="form-group" v-if="templateId === '6'">
            <label>{{ $t('sottotitolo') || 'Sottotitolo' }}</label>
            <input
              type="text"
              v-model="subtitle"
              :placeholder="$t('inserisci_sottotitolo') || 'Sappori autentici...'"
              class="form-control"
            />
          </div>

          <div class="form-group" v-if="templateId === '6'">
            <label>{{ $t('descrizione') || 'Descrizione' }}</label>
            <textarea
              v-model="description"
              :placeholder="$t('inserisci_descrizione') || 'Scopri i nostri piatti...'"
              class="form-control"
              rows="4"
            ></textarea>
          </div>

          <div class="form-group" v-if="templateId === '6'">
            <label>Orari</label>
            <input
              type="text"
              v-model="openingHours"
              placeholder="Es. Aperti tutti i giorni 12:00 – 23:00"
              class="form-control"
            />
          </div>

          <div class="form-group" v-if="templateId === '6'">
            <label>Indirizzo (Posizione Centrale)</label>
            <input
              type="text"
              v-model="address"
              placeholder="Es. Nel cuore della città"
              class="form-control"
            />
          </div>

          <div class="form-group" v-if="templateId === '6'">
            <label>Testo Qualità</label>
            <input
              type="text"
              v-model="qualityText"
              placeholder="Es. Ingredienti freschi e recensioni 5 stelle"
              class="form-control"
            />
          </div>

          <div class="form-group" v-if="templateId === '6'">
            <label>Telefono</label>
            <input
              type="text"
              v-model="phone"
              placeholder="Es. +39 123 456 7890"
              class="form-control"
            />
          </div>

          <div class="form-group" v-if="templateId === '6'">
            <label>URL Mappa Gmap (Embed)</label>
            <input
              type="text"
              v-model="mapsEmbedUrl"
              placeholder="Es. https://www.google.com/maps/embed?..."
              class="form-control"
            />
          </div>

          <div class="form-group" v-if="templateId === '6'">
            <label>URL Mappa Gmap (Link Place)</label>
            <input
              type="text"
              v-model="mapsPlaceUrl"
              placeholder="Es. https://maps.app.goo.gl/..."
              class="form-control"
            />
          </div>

          <div class="form-group" v-if="templateId === '6'">
            <label>Email Contatto</label>
            <input
              type="email"
              v-model="email"
              placeholder="Es. info@ristorante.it"
              class="form-control"
            />
          </div>

          <div class="form-group" v-if="templateId === '6'">
            <label>Partita IVA</label>
            <input
              type="text"
              v-model="partitaIva"
              placeholder="Es. 12345678901"
              class="form-control"
            />
          </div>

          <div class="form-group">
            <label>{{ $t('logo_o_immagine_hero') }}</label>
            <div class="file-upload-zone">
              <input
                type="file"
                ref="file"
                @change="onFileSelected"
                class="hidden-input"
                id="file-upload"
              />
              <label for="file-upload" class="upload-label">
                <i class="fas fa-cloud-upload-alt"></i>
                <span>{{ type ? type : $t('carica_immagine') }}</span>
              </label>
              <button 
                v-if="type" 
                @click="onSubmit" 
                class="btn-submit-file"
                :disabled="!$refs.file || !$refs.file.files.length"
              >
                {{ $t('conferma_caricamento') }}
              </button>
            </div>
          </div>
        </section>
      </div>

      <footer class="controls-footer">
        <button class="btn-save" @click="saveFile">
          <i class="fas fa-save"></i> {{ $t('salva_modifiche') }}
        </button>
      </footer>
    </aside>

    <!-- Right Content: Live Preview -->
    <main class="preview-container">
      <div class="preview-header">
        <span><i class="fas fa-eye"></i> {{ $t('anteprima_live') }}</span>
        <div class="device-toggles">
          <button 
            @click="previewMode = 'mobile'" 
            :class="{ active: previewMode === 'mobile' }"
          >
            <i class="fas fa-mobile-alt"></i>
          </button>
          <button 
            @click="previewMode = 'desktop'" 
            :class="{ active: previewMode === 'desktop' }"
          >
            <i class="fas fa-desktop"></i>
          </button>
        </div>
      </div>
      
      <div class="preview-viewport" :class="previewMode">
        <!-- Phone Frame Wrapper -->
        <div v-if="previewMode === 'mobile'" class="phone-frame">
          <div class="phone-screen">
            <div class="live-welcome-page" :style="customStyle">
              <div v-if="templateId === '1'" class="t1-preview">
                <div class="hero" :style="{ background: color || '#000' }">
                  <img :src="srcImg" v-if="srcImg" class="logo" />
                  <h1>{{ welcome || $t('client_welcome_msg') }}</h1>
                </div>
                <div class="grid">
                  <div class="item"><span>{{ $t('client_menu') }}</span></div>
                  <div class="item active" :style="{ background: color }"><span>{{ $t('client_asporto') }}</span></div>
                  <div class="item"><span>{{ $t('client_dolci') }}</span></div>
                  <div class="item"><span>{{ $t('client_feedback') }}</span></div>
                </div>
                <div class="footer" :style="{ background: color || '#000' }">
                  {{ $t('client_footer') }}
                </div>
              </div>

              <div v-else-if="templateId === '2'" class="t2-preview">
                 <nav><img :src="srcImg" v-if="srcImg" class="mini-logo" /></nav>
                 <main>
                   <h2>{{ welcome || $t('client_welcome_msg') }}</h2>
                   <div class="btns">
                     <button>{{ $t('client_menu') }}</button>
                     <button class="outline" :style="{ borderColor: color }">{{ $t('client_asporto') }}</button>
                   </div>
                 </main>
              </div>

              <div v-else-if="templateId === '3'" class="t3-preview">
                <div class="overlay" :style="{ background: `linear-gradient(135deg, ${color || '#000'} 0%, #000 100%)` }"></div>
                <div class="content">
                  <img :src="srcImg" v-if="srcImg" class="logo" />
                  <p>{{ welcome || $t('client_welcome_msg') }}</p>
                  <div class="btns">
                    <div class="glass-btn"><span>🍽️</span> {{ $t('client_menu') }}</div>
                    <div class="glass-btn"><span>🥡</span> {{ $t('client_asporto') }}</div>
                  </div>
                </div>
              </div>

              <div v-else-if="templateId === '4'" class="t4-preview">
                <header :style="{ borderBottom: `2px double ${color || '#333'}` }">
                  <img :src="srcImg" v-if="srcImg" class="logo" />
                  <h1>{{ welcome || 'Ristorante Fiore' }}</h1>
                </header>
                <div class="about">
                  <h3>{{ $t('about') }}</h3>
                  <p>{{ chiSiamoText || 'Benvenuti nel nostro ristorante...' }}</p>
                </div>
              </div>

              <div v-else-if="templateId === '5'" class="t5-preview">
                <div class="hero" :style="{ backgroundImage: srcImg ? `url(${srcImg})` : 'none' }">
                  <div class="overlay">
                    <h1>{{ welcome || $t('client_welcome_msg') }}</h1>
                    <button :style="{ background: color }">{{ $t('client_menu') }}</button>
                  </div>
                </div>
                <div class="info">
                  <h3>{{ $t('il_nostro_posto') }}</h3>
                  <p>{{ chiSiamoText || 'Una location unica...' }}</p>
                </div>
              </div>

              <!-- TEMPLATE 6 -->
              <div v-else-if="templateId === '6'" class="template-6 fresh-modern">
                <!-- HERO SECTION -->
                <div class="t6-hero">
                  <h1 class="t6-title" :style="{ color: color || '#1a202c' }">
                    {{ welcome || 'Ristorante Fresco' }}
                  </h1>
                  <p class="t6-subtitle">
                    {{ subtitle || "Cucina autentica, ingredienti selezionati e un'atmosfera moderna. Scopri i nostri piatti oppure ordina comodamente da casa." }}
                  </p>
                  
                  <div class="t6-actions">
                    <button class="t6-btn t6-btn-dark" :style="{ backgroundColor: color || '#111827' }">
                      <i class="fas fa-utensils"></i> {{ $t('client_menu') }}
                    </button>
                    <button class="t6-btn t6-btn-outline">
                      <i class="fas fa-shopping-bag"></i> {{ $t('client_asporto') }}
                    </button>
                  </div>
                </div>

                <!-- CARDS SECTION -->
                <div class="t6-features">
                  <div class="t6-card">
                    <i class="far fa-clock t6-icon"></i>
                    <h4>Orari Flessibili</h4>
                    <p>{{ openingHours || 'Aperto tutti i giorni dalle 12:00 alle 23:00.' }}</p>
                  </div>
                  <div class="t6-card">
                    <i class="fas fa-map-marker-alt t6-icon"></i>
                    <h4>Posizione Centrale</h4>
                    <p>{{ address || 'Nel cuore della città, facilmente raggiungibile.' }}</p>
                  </div>
                  <div class="t6-card">
                    <i class="far fa-star t6-icon"></i>
                    <h4>Qualità Garantita</h4>
                    <p>{{ qualityText || 'Ingredienti freschi e recensioni a 5 stelle.' }}</p>
                  </div>
                </div>

                <!-- CTA SECTION -->
                <div class="t6-cta">
                  <h2 class="t6-cta-title" :style="{ color: color || '#1a202c' }">Prenota un tavolo o ordina ora</h2>
                  <p class="t6-cta-subtitle">
                    {{ description || "Vivi l'esperienza del nostro ristorante direttamente in sala oppure comodamente a casa tua." }}
                  </p>
                  <div class="t6-actions">
                    <button class="t6-btn t6-btn-dark" :style="{ backgroundColor: color || '#111827' }">
                      {{ $t('client_menu') }}
                    </button>
                    <button class="t6-btn t6-btn-outline">
                      {{ $t('client_asporto') }}
                    </button>
                  </div>
                </div>

                <!-- MAPS SECTION -->
                <div v-if="mapsEmbedUrl" class="t6-map-section">
                   <iframe :src="mapsEmbedUrl" width="100%" height="250" style="border:0; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);" allowfullscreen="" loading="lazy"></iframe>
                </div>

                <!-- FOOTER STRIP -->
                <div class="t6-footer-strip">
                  <div class="t6-contact-info">
                    <a v-if="email" :href="`mailto:${email}`" class="t6-contact-link"><i class="far fa-envelope"></i></a>
                    <a v-if="phone" :href="`tel:${phone}`" class="t6-contact-link"><i class="fas fa-phone"></i></a>
                    <span v-if="partitaIva" class="t6-piva">P.IVA: {{ partitaIva }}</span>
                  </div>
                  <div class="t6-waiter">
                     <img src="../assets/waiter.svg" class="waiter-icon" />
                     <span>{{ $t('call_us') }}</span>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <!-- Desktop Frame Wrapper -->
        <div v-else class="desktop-frame">
          <div class="desktop-header">
            <div class="browser-dots">
              <span></span><span></span><span></span>
            </div>
            <div class="browser-address-bar">{{ store.path.split('/')[2] }}</div>
          </div>
          <div class="desktop-screen">
            <div class="live-welcome-page" :style="customStyle">
              <!-- TEMPLATE 1 -->
              <div v-if="templateId === '1'" class="t1-preview">
                <div class="hero" :style="{ background: color || '#000' }">
                  <img :src="srcImg" v-if="srcImg" class="logo" />
                  <h1>{{ welcome || $t('client_welcome_msg') }}</h1>
                </div>
                <div class="grid">
                  <div class="item"><span>{{ $t('client_menu') }}</span></div>
                  <div class="item active" :style="{ background: color }"><span>{{ $t('client_asporto') }}</span></div>
                  <div class="item"><span>{{ $t('client_dolci') }}</span></div>
                  <div class="item"><span>{{ $t('client_feedback') }}</span></div>
                </div>
                <div class="footer" :style="{ background: color || '#000' }">
                  {{ $t('client_footer') }}
                </div>
              </div>

              <!-- TEMPLATE 2 -->
              <div v-else-if="templateId === '2'" class="t2-preview">
                 <nav><img :src="srcImg" v-if="srcImg" class="mini-logo" /></nav>
                 <main>
                   <h2>{{ welcome || $t('client_welcome_msg') }}</h2>
                   <div class="btns">
                     <button>{{ $t('client_menu') }}</button>
                     <button class="outline" :style="{ borderColor: color }">{{ $t('client_asporto') }}</button>
                   </div>
                 </main>
              </div>

              <!-- TEMPLATE 3 -->
              <div v-else-if="templateId === '3'" class="t3-preview">
                <div class="overlay" :style="{ background: `linear-gradient(135deg, ${color || '#000'} 0%, #000 100%)` }"></div>
                <div class="content">
                  <img :src="srcImg" v-if="srcImg" class="logo" />
                  <p>{{ welcome || $t('client_welcome_msg') }}</p>
                  <div class="btns">
                    <div class="glass-btn"><span>🍽️</span> {{ $t('client_menu') }}</div>
                    <div class="glass-btn"><span>🥡</span> {{ $t('client_asporto') }}</div>
                  </div>
                </div>
              </div>

              <!-- TEMPLATE 4 -->
              <div v-else-if="templateId === '4'" class="t4-preview">
                <header :style="{ borderBottom: `2px double ${color || '#333'}` }">
                  <img :src="srcImg" v-if="srcImg" class="logo" />
                  <h1>{{ welcome || 'Ristorante Fiore' }}</h1>
                </header>
                <div class="about">
                  <h3>{{ $t('about') }}</h3>
                  <p>{{ chiSiamoText || 'Benvenuti nel nostro ristorante...' }}</p>
                </div>
              </div>

              <!-- TEMPLATE 5 -->
              <div v-else-if="templateId === '5'" class="t5-preview">
                <div class="hero" :style="{ backgroundImage: srcImg ? `url(${srcImg})` : 'none' }">
                  <div class="overlay">
                    <h1>{{ welcome || $t('client_welcome_msg') }}</h1>
                    <button :style="{ background: color }">{{ $t('client_menu') }}</button>
                  </div>
                </div>
                <div class="info">
                  <h3>{{ $t('il_nostro_posto') }}</h3>
                  <p>{{ chiSiamoText || 'Una location unica...' }}</p>
                </div>
              </div>

              <!-- TEMPLATE 6 -->
              <div v-else-if="templateId === '6'" class="template-6 fresh-modern">
                <!-- HEADER -->
                <header class="fresh-header" :style="{ backgroundColor: color }">
                  <img v-if="srcImg" :src="srcImg" class="fresh-logo" alt="Logo" />
                  <h1 class="fresh-title">
                    {{ welcome || 'Ristorante Aura' }}
                  </h1>
                  <p class="fresh-subtitle">
                    {{ subtitle || 'Sapori autentici, atmosfera moderna.' }}
                  </p>
                </header>
                <!-- BODY -->
                <div class="fresh-body">
                  <!-- HERO SECTION -->
                  <section class="fresh-hero">
                    <p class="hero-description">
                      {{ description || 'Scopri i nostri piatti preparati con ingredienti freschi e selezionati. Vivi l’esperienza in sala oppure ordina comodamente da casa.' }}
                    </p>
                  </section>
                  <!-- ACTION BUTTONS -->
                  <div class="fresh-actions">
                    <button class="fresh-btn primary-btn" :style="{ backgroundColor: color }">
                      {{ $t('client_menu') }}
                    </button>
                    <button class="fresh-btn outline-btn" :style="{ borderColor: color, color: color }">
                      {{ $t('client_asporto') }}
                    </button>
                  </div>
                </div>
                <!-- FOOTER -->
                <footer class="fresh-footer">
                  <div class="fresh-footer-content">
                    <img src="../assets/waiter.svg" class="waiter-icon" v-if="false" />
                    <span>{{ $t('call_us') || 'Chiama il Cameriere' }}</span>
                  </div>
                </footer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { ColorPicker } from "vue-color-kit";
import { store } from "../store/store.js";
import axios from 'axios';
import "vue-color-kit/dist/vue-color-kit.css";

export default {
  name: "ChangeLayout",
  components: {
    ColorPicker,
  },
  data() {
    return {
      color: "#000000",
      welcome: "",
      templateId: "1",
      chiSiamoText: "",
      subtitle: "",
      description: "",
      openingHours: "",
      address: "",
      qualityText: "",
      phone: "",
      mapsEmbedUrl: "",
      mapsPlaceUrl: "",
      email: "",
      partitaIva: "",
      type: "",
      srcImg: "",
      previewMode: "mobile",
      store,
    };
  },
  computed: {
    customStyle() {
      return {
        '--theme-color': this.color || '#000000'
      }
    }
  },
  methods: {
    changeColor(color) {
      const { r, g, b, a } = color.rgba;
      this.color = `rgba(${r}, ${g}, ${b}, ${a})`;
    },
        home() {
        this.$router.push({ name: "Gestionale"})
    },
    onFileSelected() {
      if (this.$refs.file.files.length > 0) {
        this.type = this.$refs.file.files[0].type.split('/')[1];
      }
    },
    async onSubmit() {
      if (!this.$refs.file.files.length) return;
      const data = new FormData();
      data.append('file', this.$refs.file.files[0]);
      try {
        const response = await axios.post(this.store.path + 'upload', data);
        if (response.data.type) {
           this.type = response.data.type;
        }
        alert(this.$t('upload_success'));
        this.displayLayout(); 
      } catch (err) {
        console.error(err);
        alert(this.$t('error_uploading'));
      }
    },
    saveFile() {
      if (!this.welcome) {
        alert(this.$t('inserisci_messaggio_benvenuto'));
        return;
      }
      this.axios
        .post(this.store.path + "valueLayout", {
          wel: this.welcome,
          col: this.color,
          type: this.type,
          templateId: this.templateId,
          chiSiamoText: this.chiSiamoText,
          subtitle: this.subtitle,
          description: this.description,
          openingHours: this.openingHours,
          address: this.address,
          qualityText: this.qualityText,
          phone: this.phone,
          mapsEmbedUrl: this.mapsEmbedUrl,
          mapsPlaceUrl: this.mapsPlaceUrl,
          email: this.email,
          partitaIva: this.partitaIva,
          headers: {
            authorization: `Bearer ${localStorage.getItem('token') ? JSON.parse(localStorage.getItem('token')) : ''}`,
          },
        })
        .then((response) => {
          alert(response.data.messaggio);
        });
    },
    displayLayout() {
      this.axios.post(this.store.path + 'displaylayout', {
        headers: {
          authorization: `Bearer ${localStorage.getItem('token') ? JSON.parse(localStorage.getItem('token')) : ''}`
        }
      }).then((response) => {
        if (response.data) {
          this.welcome = response.data.wel || "";
          this.color = response.data.col || "#000000";
          this.templateId = response.data.templateId || "1";
          this.chiSiamoText = response.data.chiSiamoText || "";
          this.subtitle = response.data.subtitle || "";
          this.description = response.data.description || "";
          this.openingHours = response.data.openingHours || "";
          this.address = response.data.address || "";
          this.qualityText = response.data.qualityText || "";
          this.phone = response.data.phone || "";
          this.mapsEmbedUrl = response.data.mapsEmbedUrl || "";
          this.mapsPlaceUrl = response.data.mapsPlaceUrl || "";
          this.email = response.data.email || "";
          this.partitaIva = response.data.partitaIva || "";
          let type = response.data.type;
          if (type) {
            this.type = type;
            let splitPat1 = this.store.path.split('/')[0];
            let splitPat2 = this.store.path.split('/')[2];
            this.srcImg = `${splitPat1}//${splitPat2}/immagine.${type}?t=${new Date().getTime()}`;
          }
        }
      });
    },
  },
  mounted() {
    this.displayLayout();
  },
};
</script>

<style scoped>
.customizer-layout {
  display: flex;
  height: 100vh;
  background: #f0f2f5;
  color: #1e293b;
  overflow: hidden;
}

/* Sidebar Styling */
.controls-sidebar {
  width: 400px;
  background: white;
  border-right: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  box-shadow: 4px 0 15px rgba(0,0,0,0.03);
  z-index: 10;
}

.controls-header {
  padding: 24px;
  border-bottom: 1px solid #f1f5f9;
}

.controls-header h1 {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  color: #0f172a;
}

.subtitle {
  font-size: 0.875rem;
  color: #64748b;
  margin: 4px 0 0;
}

.scroll-area {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
}

.control-section {
  margin-bottom: 32px;
}

.section-title {
  font-size: 1rem;
  font-weight: 600;
  color: #334155;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 8px;
  color: #475569;
}

.form-control, .form-select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-size: 0.95rem;
  transition: all 0.2s;
}

.form-control:focus, .form-select:focus {
  border-color: #3b82f6;
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.color-picker-wrapper {
  background: #f8fafc;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.file-upload-zone {
  border: 2px dashed #cbd5e1;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  background: #f8fafc;
  transition: background 0.2s;
}

.file-upload-zone:hover {
  background: #f1f5f9;
}

.upload-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #64748b;
  cursor: pointer;
}

.hidden-input {
  display: none;
}

.btn-submit-file {
  margin-top: 12px;
  padding: 6px 16px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 0.875rem;
}

.controls-footer {
  padding: 24px;
  border-top: 1px solid #f1f5f9;
  background: white;
}

.btn-save {
  width: 100%;
  padding: 14px;
  background: #10b981;
  color: white;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-save:hover {
  background: #059669;
}

/* Preview Area */
.preview-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #cbd5e1;
}

.preview-header {
  height: 60px;
  background: white;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  font-weight: 600;
}

.device-toggles {
  display: flex;
  gap: 8px;
  background: #f1f5f9;
  padding: 4px;
  border-radius: 8px;
}

.device-toggles button {
  background: none;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  color: #64748b;
  transition: all 0.2s;
}

.device-toggles button.active {
  background: white;
  color: #3b82f6;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.preview-viewport {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  overflow: hidden;
}

.preview-viewport.desktop {
  padding: 20px;
}

/* Mock Phone Frame */
.phone-frame {
  width: 340px;
  height: 680px;
  background: #1e293b;
  border-radius: 40px;
  padding: 12px;
  box-shadow: 0 25px 50px -12px rgba(0,0,0,0.5);
  position: relative;
}

.phone-screen {
  width: 100%;
  height: 100%;
  background: white;
  border-radius: 30px;
  overflow: hidden;
  position: relative;
}

/* Desktop Frame */
.desktop-frame {
  width: 100%;
  height: 100%;
  max-width: 1000px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

.desktop-header {
  height: 40px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  padding: 0 16px;
  gap: 20px;
}

.browser-dots {
  display: flex;
  gap: 6px;
}

.browser-dots span {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #cbd5e1;
}

.browser-address-bar {
  flex: 1;
  background: white;
  height: 24px;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
  font-size: 11px;
  color: #94a3b8;
  display: flex;
  align-items: center;
  padding: 0 10px;
}

.desktop-screen {
  flex: 1;
  overflow-y: auto;
}

/* Live Preview Micro-styles */
.live-welcome-page {
  height: 100%;
  font-family: inherit;
  font-size: 14px;
  overflow-y: auto;
}

/* T1 Styles */
.t1-preview .hero { 
  height: 40%; display: flex; flex-direction: column; align-items: center; justify-content: center; color: white; padding: 20px; text-align: center;
}
.desktop .t1-preview .hero { height: 300px; }
.t1-preview .logo { width: 60px; border-radius: 50%; margin-bottom: 10px; }
.t1-preview h1 { font-size: 18px; margin: 0; }
.t1-preview .grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; padding: 15px; }
.desktop .t1-preview .grid { grid-template-columns: repeat(4, 1fr); max-width: 800px; margin: 0 auto; }
.t1-preview .item { background: #f1f5f9; padding: 20px; border-radius: 10px; text-align: center; font-weight: bold; font-size: 12px; }
.t1-preview .active { color: white; }
.t1-preview .footer { height: 40px; display: flex; align-items: center; justify-content: center; color: white; font-size: 10px; }

/* T2 Styles */
.t2-preview { padding: 30px 15px; display: flex; flex-direction: column; height: 100%; }
.desktop .t2-preview { max-width: 800px; margin: 0 auto; padding: 60px 20px; }
.t2-preview nav { margin-bottom: 40px; }
.t2-preview .mini-logo { height: 30px; }
.t2-preview h2 { font-size: 22px; margin-bottom: 30px; }
.t2-preview .btns button { display: block; width: 100%; padding: 12px; margin-bottom: 10px; border: 1px solid #eee; background: none; border-radius: 4px; }

/* T3 Styles */
.t3-preview { position: relative; height: 100%; background: #000; color: white; }
.t3-preview .overlay { position: absolute; top: 0; left: 0; width: 100%; height: 100%; opacity: 0.8; }
.t3-preview .content { position: relative; z-index: 2; padding: 30px; text-align: center; }
.desktop .t3-preview .content { padding: 80px 20px; }
.t3-preview .logo { width: 60px; margin-bottom: 20px; }
.t3-preview .glass-btn { background: rgba(255,255,255,0.1); padding: 15px; border-radius: 12px; margin-bottom: 10px; font-size: 12px; }

/* T4 Styles */
.t4-preview { padding: 20px; }
.desktop .t4-preview { max-width: 900px; margin: 0 auto; padding: 40px; }
.t4-preview header { text-align: center; padding: 20px 0; margin-bottom: 20px; }
.t4-preview .logo { width: 50px; margin-bottom: 10px; }
.t4-preview h1 { font-size: 20px; }
.t4-preview .about { text-align: center; color: #64748b; font-size: 13px; line-height: 1.6; }

/* T5 Styles */
.t5-preview .hero { height: 50%; background-size: cover; background-position: center; position: relative; }
.desktop .t5-preview .hero { height: 400px; }
.t5-preview .overlay { position: absolute; inset: 0; background: rgba(0,0,0,0.5); display: flex; flex-direction: column; align-items: center; justify-content: center; color: white; padding: 20px; text-align: center; }
.t5-preview h1 { font-size: 18px; margin-bottom: 15px; }
.t5-preview button { border: none; padding: 10px 20px; color: white; border-radius: 4px; }
.t5-preview .info { padding: 20px; text-align: center; }
.t5-preview h3 { font-size: 14px; margin-bottom: 8px; }
.t5-preview p { font-size: 12px; color: #64748b; }

/* T6 Styles */
.template-6 { display: flex; flex-direction: column; min-height: 100%; background: linear-gradient(to bottom, #ffffff, #f7f9fc); font-family: 'Inter', sans-serif; }
.desktop .template-6 { max-width: 800px; margin: 0 auto; min-height: 600px; border-radius: 12px; overflow: hidden; }
.fresh-header { padding: 40px 20px; text-align: center; color: white; }
.fresh-logo { width: 80px; margin-bottom: 15px; }
.fresh-title { font-size: 32px; font-weight: 700; margin: 0; }
.fresh-subtitle { font-size: 16px; opacity: 0.9; margin-top: 8px; }
.fresh-body { flex: 1; padding: 30px 20px; text-align: center; }
.fresh-hero { margin-bottom: 40px; }
.hero-description { font-size: 17px; color: #555; max-width: 500px; margin: 0 auto; line-height: 1.6; }
.fresh-actions { display: flex; flex-direction: column; gap: 16px; align-items: center; }
.fresh-btn { width: 100%; max-width: 320px; padding: 14px; font-size: 16px; border-radius: 14px; cursor: pointer; transition: all 0.3s ease; }
.primary-btn { color: white; border: none; }
.outline-btn { background: white; border: 2px solid; }
.fresh-footer { padding: 15px; background: #ffffff; border-top: 1px solid #eee; }
.fresh-footer-content { display: flex; justify-content: center; align-items: center; gap: 10px; cursor: pointer; font-size: 14px; color: #444; }

@media (max-width: 900px) {
  .controls-sidebar { width: 300px; }
}

/* TEMPLATE 6 REWRITE Preview */
.template-6.fresh-modern {
  background-color: #fcfcfc;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: 'Inter', sans-serif;
  color: #1a202c;
  padding: 40px 20px;
  gap: 40px;
  align-items: center;
}

.t6-hero, .t6-cta {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 800px;
  width: 100%;
}

.t6-title, .t6-cta-title {
  font-size: 32px;
  font-weight: 800;
  margin-bottom: 12px;
  color: #1a202c;
  letter-spacing: -0.5px;
}

.t6-subtitle, .t6-cta-subtitle {
  font-size: 14px;
  color: #4a5568;
  margin-bottom: 24px;
  line-height: 1.6;
}

.t6-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

.t6-btn {
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
}

.t6-btn-dark {
  background-color: #111827;
  color: #ffffff;
  border: 1px solid #111827;
}

.t6-btn-outline {
  background-color: #ffffff;
  color: #111827;
  border: 1px solid #e2e8f0;
}

.t6-features {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  width: 100%;
  max-width: 1000px;
}

.t6-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 1px 3px rgba(0,0,0,0.02);
}

.t6-icon {
  font-size: 22px;
  color: #1a202c;
  margin-bottom: 12px;
}

.t6-card h4 {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 8px;
  color: #1a202c;
}

.t6-card p {
  font-size: 13px;
  color: #718096;
  line-height: 1.5;
}

.t6-map-section {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
}

.t6-footer-strip {
  width: 100%;
  max-width: 1000px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 24px;
  border-top: 1px solid #e2e8f0;
  flex-wrap: wrap;
  gap: 16px;
}

.t6-contact-info {
  display: flex;
  align-items: center;
  gap: 16px;
}

.t6-contact-link {
  color: #4a5568;
  font-size: 20px;
}

.t6-piva {
  font-size: 12px;
  color: #718096;
  font-weight: 500;
}

.t6-waiter {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #1a202c;
  font-size: 14px;
}
.t6-waiter img {
  width: 24px;
}

/* Phone frame adjustments */
.phone-screen .t6-features {
  grid-template-columns: 1fr;
}
.phone-screen .t6-footer-strip {
  flex-direction: column;
  text-align: center;
  justify-content: center;
}

.sci-btn-back {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  padding: 0 16px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  color: #475569;
  font-weight: 600;
  font-size: 0.88rem;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.22, 1, 0.36, 1);
}

.sci-btn-back:hover {
  background: #f1f5f9;
  color: #0f172a;
  border-color: #cbd5e1;
}
</style>
